<div class="container" style="margin-left:0;margin-right:0;">
  <form *ngIf="isCommonDataLoaded" name="tableItemEditForm" #tableItemEditForm="ngForm">
    <fieldset [disabled]="item.notEditable === true || isAIndeferir == true">

      <div class="row">
        <!--Tem nacionalidade portuguesa?-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset required [disabled]="isFieldDisabled('hasNacPT') || estadoPendente">
              <label for="hasPortugueseNationality" [class.disabled]="isFieldDisabled('hasNacPT') || estadoPendente">
                <span class="mandatory" [style.color]="(isFieldDisabled('hasNacPT') || estadoPendente)?'#9F9F9F':'#DB3347'">*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNationality' | translate}}
              </label>
              <div class="btn-group btn-group-toggle  maxWidth">
                <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle" [class.active]="domain.value==item.hasNacPT?.toString()" [radioLabel]="hasPortugueseNationality">
                  <input type="radio"
                         [(ngModel)]="item.hasNacPT"
                         name="hasPortugueseNationality"
                         (change)="hasPortugueseNationalityChange(item.hasNacPT)"
                         #hasLegalRepresentation="ngModel"
                         [value]="domain.value"
                         [disabled]="isFieldDisabled('hasNacPT') || estadoPendente"
                         required>
                  {{domain.description}}
                </label>
                <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
                <!--<span>item.hasNacPT:{{item.hasNacPT}}</span>-->
              </div>
            </fieldset>
          </div>
        </div>

        <!--Tem nif portugues?-->
        <!--<div class="col-sm-4">
      <div class="form-group">
        <fieldset >
          <label for="hasPortugueseNif"><span class="mandatory" disabled>*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNif' | translate}}</label>
          <div class="btn-group btn-group-toggle">
            <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle" [class.active]="domain.value==item.hasNIFPT?.toString()" [radioLabel]="hasPortugueseNif">
              <input type="radio"
                     [(ngModel)]="item.hasNIFPT"
                       (change)="hasPortugueseNifChange(item.hasNIFPT)"
                     name="hasPortugueseNif"
                     #hasLegalRepresentation="ngModel"
                     [value]="domain.value">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>-->
        <!--NIF-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset [disabled]="(notEditable || item.notEditable || isFieldDisabled('NIF')) ">
              <label for="NIF" [class.disabled]="(notEditable || item.notEditable || isFieldDisabled('NIF'))">
                <span class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NIF' | translate}}
              </label>
              <input class="form-control"
                     type="number"
                     numeric="9"
                     [(ngModel)]="item.NIF"
                     name="NIF"
                     #NIF="ngModel"
                     maxlength="9"
                     nifValidation
                     required>
              <validation-message [control]="NIF"></validation-message>
            </fieldset>
          </div>
        </div>

      </div>
    </fieldset>
      <div class="row">
        <!--Tipo de representação legal-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset>
              <label for="representationType" [class.disabled]="item.notEditable && !rlRlStateAguardaDocumentos">
                <span class="mandatory" [style.color]="(item.notEditable && !rlRlStateAguardaDocumentos || estadoPendente)?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.RepresentationType' | translate}}
              </label>
              <select class="custom-select "
                      [(ngModel)]="item.representationType"
                      name="representationType"
                      #representationType="ngModel"
                      [disabled]="item.notEditable && !rlRlStateAguardaDocumentos"
                      required
                      [dropdownTitle]="{value : item.representationType, dimensions :  typesRepresentation }"
                      nullableSelect>
                <default-dropdown-values></default-dropdown-values>
                <option *ngFor="let domain of dropListRepresentationType" [value]="domain.value">
                  {{domain.description}}
                </option>
              </select>
              <validation-message [control]="representationType"></validation-message>
            </fieldset>
          </div>

        </div>

        <!--Estado de representação legal-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset disabled>
              <label for="stateRL">
                <!--<span class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>-->
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.LegalRepresentationState' | translate}}
              </label>
              <input class="form-control" #stateRL readonly [value]="getStateText(item.stateRL?.toString())" />

              <validation-message [control]="stateRL"></validation-message>
            </fieldset>
          </div>

        </div>
      </div>

    
    <div class="row">
      <!--Motivo de rejeição da representação legal-->
      <div class="col-sm-12" *ngIf="item.rejectionReason != null && item.rejectionReason != undefined && isAIndeferir == false">
        <div class="form-group">
          <fieldset>
            <label for="rejectionReason" class="form-control-disabled">
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.RejectionReason' | translate}}
            </label>
            <textarea class="form-control input-right form-control-disabled" rows="3" type="text" [(ngModel)]="item.rejectionReason"
                      [maxLength]="1024"
                      readonly
                      [rows]="isRLIndeferida?10:4"
                      #rejectionReason="ngModel" name="rejectionReason"
                      messageFieldType="string"></textarea>
            <validation-message [control]="rejectionReason"></validation-message>
          </fieldset>
        </div>
      </div>
    </div>


      <!--Beneficio requerido-->
      <div class="row">
        <div class="col-12">
          <div class="form-group text-secondary ft-sz-15">
            <label for="Campos obrigatórios" [style.color]="((estadoPendente || item.notEditable) && !rlRlStateAguardaDocumentos)?'#9F9F9F':'#545454'">
              <span [style.color]="((estadoPendente || item.notEditable) && !rlRlStateAguardaDocumentos)?'#9F9F9F':'#DB3347'" class="mandatory">*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.BenefitMandatory' | translate}}
            </label>
          </div>
        </div>
      </div>

      <!--Pensão de sobrevivência -->
      <div class="row">
        <div class="col-sm-12 ml-2">
          <div class="form-check mb-4" style="cursor:pointer;">
            <input class="form-check-input"
                   [disabled]="item.notEditable && !rlRlStateAguardaDocumentos"
                   aria-controls="collapseManual"
                   type="checkbox"
                   [(ngModel)]="item.survivalPensionBenefit"
                   name="survivalPensionBenefit"
                   #survivalPensionBenefit="ngModel"
                   id="PensaoSobreviviencia" />
            <label class="form-check-label align-items-center " for="PensaoSobreviviencia">
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.SurvivalPensionBenefit' | translate}}
              <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleSurvivalPensionBenefit ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation();toggleVisibilitySurvivalPensionBenefit()"></span>
            </label>
            <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleSurvivalPensionBenefit" style="text-align: justify;">
              <br />
              <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.SurvivalPensionBenefitTooltip' | translate}}</span>
            </div>
          </div>
        </div>
      </div>

      <!--Reembolso de despesas de funeral -->
      <div class="row">
        <div class="col-sm-12 ml-2">
          <div class="form-check mb-4">
            <input class="form-check-input"
                   [disabled]="item.notEditable && !rlRlStateAguardaDocumentos"
                   aria-controls="collapseManual"
                   type="checkbox"
                   [(ngModel)]="item.reimbursementFuneralBenefit"
                   name="reimbursementFuneralBenefit"
                   #reimbursementFuneralBenefit="ngModel"
                   id="ReembolsoDespesasFuneral">
            <label class="form-check-label align-items-center " for="ReembolsoDespesasFuneral">
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.ReimbursementFuneralBenefit' | translate}}
              <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleReimbursementFuneralBenefit ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation();toggleVisibilityReimbursementFuneralBenefit()"></span>
            </label>
            <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleReimbursementFuneralBenefit" style="text-align: justify;">
              <br />
              <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.ReimbursementFuneralBenefitTooltip' | translate}}</span>
            </div>
          </div>
        </div>
      </div>

      <!--Subsídio de morte -->
      <div class="row">
        <div class="col-sm-12 ml-2">
          <div class="form-check mb-4">
            <input class="form-check-input"
                   [disabled]="item.notEditable && !rlRlStateAguardaDocumentos"
                   aria-controls="collapseManual"
                   type="checkbox"
                   [(ngModel)]="item.funeralAllowanceBenefit"
                   name="funeralAllowanceBenefit"
                   #funeralAllowanceBenefit="ngModel"
                   id="SubsidioMorte">
            <label class="form-check-label align-items-center " for="SubsidioMorte">
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.FuneralAllowanceBenefit' | translate}}
              <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleFuneralAllowanceBenefit ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation();toggleVisibilityFuneralAllowanceBenefit()"></span>
            </label>
            <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleFuneralAllowanceBenefit" style="text-align: justify;">
              <br />
              <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.FuneralAllowanceBenefitTooltip' | translate}}</span>
            </div>
          </div>
        </div>
      </div>

      <!--<span>(tableItemEditForm.valid : {{tableItemEditForm.valid}}</span>-->
      <div class="d-flex justify-content-between mt-4 mb-2">
        <button type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="onRemove(isEdit)">
          <!-- (click)="expandNewBeneficiary=!expandNewBeneficiary" -->
          <span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span>
        </button>
        <button [disabled]="!(tableItemEditForm.valid && isFormValid() ) "
                type="button" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)">
          <span class="icon-check"></span><span>Aplicar</span>
        </button>
      </div>


  </form>
 
</div>
